export default __webpack_public_path__ + "static/media/added-to-favourites-new.1ccb67db.svg";